// -------------------------------------------------------------------------------------------------
// NortonLifeLock copyright header start
// ----------------------
//
// PROPRIETARY / CONFIDENTIAL.
// Use of this product is subject to license terms.
// Copyright (c) 2022 NortonLifeLock
// All rights reserved.
//
// -------------------------------------------------------------------------------------------------
// NortonLifeLock copyright header stop
// ----------------------
import React from 'react';
import styled from 'styled-components';
import { routes } from './routes';
import { AntitrackHeader, GlobalStyle, responsive } from './components';

const PageContent = styled.div`
  background: var(--nll-gray05);
  width: 100vw;
  padding: 1.5625rem;

  ${responsive.tablet`
    padding: 1.5625rem 7.25rem;
  `}

  ${responsive.mobile`
    padding: 1.5625rem;
  `}
`;

const Container = styled.div``;

export function App() {
  return (
    <PageContent>
      <GlobalStyle />
      <AntitrackHeader />
      <Container>{routes}</Container>
    </PageContent>
  );
}
